import {
  ACTIVE,
  ALL,
  CHANGE_PASSWORD,
  CLIENTS,
  COMPANY,
  CUSTOMERS,
  DOCUMENTS,
  END,
  ENDED,
  FOSTER_FAMILIES,
  FULL,
  HOME,
  INACTIVATED,
  INACTIVE,
  LIST,
  NEW,
  PENDING,
  PLACEMENTS,
  PROFILE,
  READY,
  ROOTS_DASHBOARD,
  USERS,
  VAULT,
} from './consts';

/**
 * Paths for auth
 */
export const PATH_AUTH = {
  login: '/login',
};

// ----------------------------------------------------------------------

/**
 * Paths for dashboard
 */
export const PATH_DASHBOARD = {
  client: {
    active: `/${ROOTS_DASHBOARD}/${CLIENTS}/${LIST}/${ACTIVE}`,
    all: `/${ROOTS_DASHBOARD}/${CLIENTS}/${LIST}/${ALL}`,
    details: (id: string) => `/${ROOTS_DASHBOARD}/${CLIENTS}/${id}`,
    documents: (id: string) =>
      `/${ROOTS_DASHBOARD}/${CLIENTS}/${id}/${DOCUMENTS}`,
    editDocument: (id: string, docId: string) =>
      `/${ROOTS_DASHBOARD}/${CLIENTS}/${id}/${DOCUMENTS}/${docId}`,
    editVaultDocument: (id: string, docId: string) =>
      `/${ROOTS_DASHBOARD}/${CLIENTS}/${id}/${VAULT}/${docId}`,
    inactive: `/${ROOTS_DASHBOARD}/${CLIENTS}/${LIST}/${INACTIVE}`,
    list: `/${ROOTS_DASHBOARD}/${CLIENTS}/${LIST}`,
    new: `/${ROOTS_DASHBOARD}/${CLIENTS}/${NEW}`,
    placements: (id: string) =>
      `/${ROOTS_DASHBOARD}/${CLIENTS}/${id}/${PLACEMENTS}`,
    profile: (id: string) => `/${ROOTS_DASHBOARD}/${CLIENTS}/${id}/${PROFILE}`,
    root: `/${ROOTS_DASHBOARD}/${CLIENTS}`,
    vault: (id: string) => `/${ROOTS_DASHBOARD}/${CLIENTS}/${id}/${VAULT}`,
  },
  company: {
    documents: `/${ROOTS_DASHBOARD}/${COMPANY}/${DOCUMENTS}`,
    editDocument: (docId: string) =>
      `/${ROOTS_DASHBOARD}/${COMPANY}/${DOCUMENTS}/${docId}`,
    editVaultDocument: (docId: string) =>
      `/${ROOTS_DASHBOARD}/${COMPANY}/${VAULT}/${docId}`,
    root: `/${ROOTS_DASHBOARD}/${COMPANY}`,
    vault: `/${ROOTS_DASHBOARD}/${COMPANY}/${VAULT}`,
  },
  customer: {
    details: (id: string) => `/${ROOTS_DASHBOARD}/${CUSTOMERS}/${id}`,
    list: `/${ROOTS_DASHBOARD}/${CUSTOMERS}/${LIST}`,
    new: `/${ROOTS_DASHBOARD}/${CUSTOMERS}/${NEW}`,
    placements: (id: string) =>
      `/${ROOTS_DASHBOARD}/${CUSTOMERS}/${id}/${PLACEMENTS}`,
    profile: (id: string) =>
      `/${ROOTS_DASHBOARD}/${CUSTOMERS}/${id}/${PROFILE}`,
    root: `/${ROOTS_DASHBOARD}/${CUSTOMERS}`,
  },
  fosterFamily: {
    all: `/${ROOTS_DASHBOARD}/${FOSTER_FAMILIES}/${LIST}/${ALL}`,
    details: (id: string) => `/${ROOTS_DASHBOARD}/${FOSTER_FAMILIES}/${id}`,
    documents: (id: string) =>
      `/${ROOTS_DASHBOARD}/${FOSTER_FAMILIES}/${id}/${DOCUMENTS}`,
    editDocument: (id: string, docId: string) =>
      `/${ROOTS_DASHBOARD}/${FOSTER_FAMILIES}/${id}/${DOCUMENTS}/${docId}`,
    editVaultDocument: (id: string, docId: string) =>
      `/${ROOTS_DASHBOARD}/${FOSTER_FAMILIES}/${id}/${VAULT}/${docId}`,
    full: `/${ROOTS_DASHBOARD}/${FOSTER_FAMILIES}/${LIST}/${FULL}`,
    inactivated: `/${ROOTS_DASHBOARD}/${FOSTER_FAMILIES}/${LIST}/${INACTIVATED}`,
    list: `/${ROOTS_DASHBOARD}/${FOSTER_FAMILIES}/${LIST}`,
    new: `/${ROOTS_DASHBOARD}/${FOSTER_FAMILIES}/${NEW}`,
    pending: `/${ROOTS_DASHBOARD}/${FOSTER_FAMILIES}/${LIST}/${PENDING}`,
    placements: (id: string) =>
      `/${ROOTS_DASHBOARD}/${FOSTER_FAMILIES}/${id}/${PLACEMENTS}`,
    profile: (id: string) =>
      `/${ROOTS_DASHBOARD}/${FOSTER_FAMILIES}/${id}/${PROFILE}`,
    ready: `/${ROOTS_DASHBOARD}/${FOSTER_FAMILIES}/${LIST}/${READY}`,
    root: `/${ROOTS_DASHBOARD}/${FOSTER_FAMILIES}`,
    vault: (id: string) =>
      `/${ROOTS_DASHBOARD}/${FOSTER_FAMILIES}/${id}/${VAULT}`,
  },
  home: `/${ROOTS_DASHBOARD}/${HOME}`,
  placement: {
    active: `/${ROOTS_DASHBOARD}/${PLACEMENTS}/${LIST}/${ACTIVE}`,
    all: `/${ROOTS_DASHBOARD}/${PLACEMENTS}/${LIST}/${ALL}`,
    end: (id: string) => `/${ROOTS_DASHBOARD}/${PLACEMENTS}/${id}/${END}`,
    ended: `/${ROOTS_DASHBOARD}/${PLACEMENTS}/${LIST}/${ENDED}`,
    list: `/${ROOTS_DASHBOARD}/${PLACEMENTS}/${LIST}`,
    new: `/${ROOTS_DASHBOARD}/${PLACEMENTS}/${NEW}`,
    profile: (id: string) =>
      `/${ROOTS_DASHBOARD}/${PLACEMENTS}/${id}/${PROFILE}`,
    root: `/${ROOTS_DASHBOARD}/${PLACEMENTS}`,
  },
  profile: `/${ROOTS_DASHBOARD}/${PROFILE}`,
  root: `/${ROOTS_DASHBOARD}`,
  user: {
    'change-password': (id: string) =>
      `/${ROOTS_DASHBOARD}/${USERS}/${id}/${CHANGE_PASSWORD}`,
    details: (id: string) => `/${ROOTS_DASHBOARD}/${USERS}/${id}`,
    list: `/${ROOTS_DASHBOARD}/${USERS}/${LIST}`,
    new: `/${ROOTS_DASHBOARD}/${USERS}/${NEW}`,
    profile: (id: string) => `/${ROOTS_DASHBOARD}/${USERS}/${id}/${PROFILE}`,
    root: `/${ROOTS_DASHBOARD}/${USERS}`,
  },
};

// ----------------------------------------------------------------------
